import { ApiRequestError, api } from '@/lib/api.ts';
import type { Level, SeatDto } from '@okn/shared';
import { useEffect, useState } from 'react';

export type EventInfo = {
  id: string;
  name: string;
  startsAt: string;
  venueName: string;
  status: string;
  reserveHoldMinutes: number;
  maxSeatsPerReservation: number;
};

export type SeatmapResponse = {
  event: EventInfo;
  seats: SeatDto[];
};

export type SeatmapByLevel = {
  event: EventInfo;
  seatsByLevel: Record<Level, SeatDto[]>;
  allSeats: SeatDto[];
};

type State =
  | { status: 'loading' }
  | { status: 'error'; message: string }
  | { status: 'ready'; data: SeatmapByLevel };

export function useSeatmap(eventId: string): State {
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading' });
    api<SeatmapResponse>(`/events/${eventId}/seatmap`)
      .then((res) => {
        if (cancelled) return;
        setState({ status: 'ready', data: groupByLevel(res) });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        const message =
          err instanceof ApiRequestError
            ? err.body.error.message
            : err instanceof Error
              ? err.message
              : 'Bilinmeyen hata';
        setState({ status: 'error', message });
      });
    return () => {
      cancelled = true;
    };
  }, [eventId]);

  return state;
}

function groupByLevel(res: SeatmapResponse): SeatmapByLevel {
  const seatsByLevel: Record<Level, SeatDto[]> = {
    ground: [],
    side_balcony_left: [],
    side_balcony_right: [],
    upper_balcony: [],
  };
  for (const s of res.seats) {
    seatsByLevel[s.level].push(s);
  }
  return { event: res.event, seatsByLevel, allSeats: res.seats };
}
